import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { ChatPanel } from '../chat/ChatPanel';
import { ChatFloatingButton } from '../chat/ChatFloatingButton';

/**
 * Main layout component
 * Maps to Req 166 AC 3: responsive layout
 * Maps to Req 166 AC 5: keyboard navigation with skip link
 * WCAG 2.1 AA compliant
 */
export const MainLayout: React.FC = () => {
  return (
    /* Sidebar is full-height on the left, with the header spanning only the
       content column beside it. Previously the header spanned the full width
       ABOVE the sidebar, which left the sidebar with no top of its own to put
       the product brand in - so the brand sat in the header, occupying the
       space where the page title belongs. This ordering gives the sidebar its
       own h-14 brand block aligned with the header, and frees the header to
       identify the page you're actually on. */
    <div className="flex h-screen">
      {/* Skip to main content link for screen readers */}
      <a href="#main-content" className="skip-to-main">
        Skip to main content
      </a>

      <Sidebar />

      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Header />

        {/* `min-w-0` (here and on the column wrapper above) is load-bearing,
            not decoration: a flex item defaults to `min-width: auto`, meaning
            it refuses to shrink below its content's intrinsic width. Any wide
            child (a table, a long unbreakable resource ARN, a fixed-width
            control row) therefore pushed this pane wider than the viewport -
            and since the parent is `overflow-hidden`, the excess was silently
            CLIPPED rather than scrolled, which is what cut the right-hand
            cards off mid-render. With min-w-0 the pane stays viewport-width
            and wide content scrolls inside its own container instead. */}
        <main
          id="main-content"
          className="min-w-0 flex-1 overflow-y-auto bg-background"
          role="main"
          tabIndex={-1}
        >
          <div className="mx-auto max-w-[1600px] p-4 sm:p-6">
            <Outlet />
          </div>
        </main>
      </div>

      <ChatPanel />
      <ChatFloatingButton />
    </div>
  );
};
